var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayStore = function SvgPlayStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2823 17.1334L12.0578 12.0056L2.03809 21.8007C2.33776 23.5668 4.34291 24.5818 5.97455 23.6426L17.2823 17.1334Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 12.0056L17.3025 6.8783L22.2045 9.70006C23.9772 10.7205 23.9771 13.2795 22.2045 14.2999L17.2822 17.1334L12.0576 12.0056Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0575 12.0056L17.3024 6.87831L5.97432 0.357446C4.35002 -0.577556 2.35561 0.424056 2.04199 2.17551L12.0575 12.0056Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0579 12.0056L2.04235 2.17554C2.01459 2.33056 2 2.49146 2 2.65741L2 21.3427C2 22.108 2.3103 22.7658 2.79142 23.2356C2.40929 22.8625 2.13493 22.3707 2.03821 21.8007L12.0579 12.0056Z",
    fill: "#4285F4"
  })));
};
export default SvgPlayStore;